export default "/images/align-center.svg?c9a0a09d9a713f6e2e7537766e5bb18b";